export default "__VITE_ASSET__BtI4Cw8i__"